import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Mechanism() {
  return <section className="py-8 md:py-12 px-5 bg-olive-700 text-cream-50" data-id="element-219">
      <div className="max-w-4xl mx-auto text-center" data-id="element-220">
        <div className="inline-flex items-center gap-2 bg-olive-600 px-4 py-1.5 rounded-full text-xs font-medium mb-6 border border-olive-500" data-id="element-221">
          MÉTODO EXCLUSIVO
        </div>

        <h2 className="font-serif font-medium text-3xl md:text-5xl leading-tight mb-6" data-id="element-222">
          Sistema de Bienestar Natural Organizado™
        </h2>

        <p className="text-cream-200 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-12" data-id="element-223">
          Más de 1,500 soluciones naturales fueron organizadas en 5 ebooks
          premium, por tema y por síntoma, para que encuentres rápidamente lo
          que necesitas sin perder tiempo buscando información dispersa.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6 text-left md:text-center" data-id="element-224">
          {['Todo organizado', 'Fácil de consultar', 'Disponible desde cualquier dispositivo', 'Ingredientes simples', 'Acceso inmediato'].map((benefit, idx) => <div key={idx} className="flex flex-row md:flex-col items-center md:justify-center gap-3 md:gap-4" data-id="element-225">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-olive-600 flex items-center justify-center" data-id="element-226">
                <CheckCircle2 className="w-5 h-5 text-cream-100" data-id="element-227" />
              </div>
              <span className="text-sm md:text-base font-medium leading-snug text-cream-100" data-id="element-228">
                {benefit}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}